import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Steps } from "antd";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CategoryForm from "../../../components/admin/category/CategoryForm";
import AddSubCategory from "../../../components/admin/category/AddSubCategory";

function CreateCategoryPage() {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if categoryId was passed (adding subcategory to existing category)
  const {
    categoryId: existingCategoryId,
    categoryName: existingCategoryName,
  } = location.state || {};

  // State
  const [currentStep, setCurrentStep] = useState(existingCategoryId ? 1 : 0);
  const [categoryId, setCategoryId] = useState(existingCategoryId || null);
  const [categoryName, setCategoryName] = useState(existingCategoryName || "");

  // Step 1 success - category data collected, move to subcategory step
  const handleCategorySuccess = (categoryData) => {
    setCategoryId(categoryData); // Store full category data object
    setCategoryName(categoryData.name);
    setCurrentStep(1);
  };

  // Step 2 success - subcategory created
  const handleSubcategorySuccess = () => {
    navigate("/category");
  };

  // Cancel handler
  const handleCancel = () => {
    navigate("/category");
  };

  // Steps configuration
  const steps = [
    { title: "Category", description: "Create category" },
    { title: "Subcategory", description: "Add subcategory" },
  ];

  return (
    <AdminLayout>
      <div className="min-h-screen bg-slate-50 px-3 sm:px-6 py-6">
        <div className="w-full max-w-6xl">
          {/* Header - same as CreateBidForm, left-aligned */}
          <div className="mb-6 text-left">
            <h1 className="text-2xl font-semibold text-gray-900">
              {existingCategoryId ? "Add Subcategory" : "Create Category"}
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              {existingCategoryId ? (
                <>
                  Adding subcategory to{" "}
                  <span className="font-semibold text-[#1955EB]">{categoryName}</span>
                </>
              ) : (
                "Create a new category with at least one subcategory"
              )}
            </p>
          </div>

          {/* Steps indicator - only show if creating new category */}
          {!existingCategoryId && (
            <div className="mb-6 max-w-lg">
              <Steps current={currentStep} items={steps} size="small" />
            </div>
          )}

          {/* Step Content - same card as CreateBidForm Basic Info */}
          <div className="bg-white p-6 rounded-xl shadow border text-left">
            {currentStep === 0 && !existingCategoryId && (
              <CategoryForm
                onSuccess={handleCategorySuccess}
                onCancel={handleCancel}
              />
            )}

            {(currentStep === 1 || existingCategoryId) && (
              <AddSubCategory
                categoryId={categoryId}
                categoryName={categoryName}
                onSuccess={handleSubcategorySuccess}
                onCancel={handleCancel}
                hideHeader={true}
              />
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default CreateCategoryPage;
